// extracted by mini-css-extract-plugin
module.exports = {"page":"Page_page__329Ps","main":"Page_main__3usLv"};